module.exports = __webpack_public_path__ + "img/EMS_user_manual9.d2eaaa07.png";